<!-- @format -->

<invoice-list-tag>
<div class="contents_block table table_top">
  <table class="contents_table">
    <tbody>
      <tr class="column_invoices-table">
        <th class="sort-cel">請求書番号<div class="button_sort-{state.orderby}" onclick={(e)=>toggleOrderby(e)}></a></th>
        <th>サービス名</th>
        <th class="sort-cel">請求日<div class="button_sort"></div></th>
        <th>支払期日</th>
        <th>請求金額(税込)</th>
        <th>ステータス</th>
        <th>担当者</th>
        <th>請求書</th>
      </tr>
      <tr each={ (invoice,i) in state.invoices }>
        <td><a class="link_outer" onclick={(e)=>detail(e,invoice)} target="_blank">{invoice.id}</a></td>
        <td>{invoice.source}</td>
        <td>{invoice.invoiced_at}</td>
        <td>{invoice.payment_due_date}</td>
        <td>{Number(invoice.price).toLocaleString()}円</td>
        <td><span class="{InvoiceStatus(invoice.status).class}">{InvoiceStatus(invoice.status).text}</span></td>
        <td>{invoice.staff}</td>
        <td><button class="button button-secondary-mini button-download" type="button" value="PDF" onclick={(e)=>pdf(e,invoice)}>PDF</button></td>
      </tr>
    </tbody>
  </table><!--/.contents_table-->
</div><!--/.contents_block-->

<editech-hub-pagination-tag pager="{state.pager}" onpager="{(e,page)=>props.updatePage(page)}" if={state.pager.last > 1}></editech-hub-pagination-tag>

<script>
  import di from "dependency-injection";
  import Status from "@model/status.js";
  export default {
    InvoiceStatus: Status.invoice,
    state: {
      orderby: 'descend',
      invoices: [],
      limit: null,
      isLoading: true,
      page: 1,
      pager: {page: 1, total: 0, last: 0,  prev: 0, next: 0}
    },
    toggleOrderby(e){
      if (this.state.orderby == 'descend') {
        this.update({orderby: 'ascend'});
        this.props.setOrderBy('asc');
      }else{
        this.update({orderby: 'descend'});
        this.props.setOrderBy('desc');
      }
    },
    pdf(e, invoice) {
      window.open(invoice.pdf_link, `invoice-pdf-${invoice.id}`);
    },
    detail(e, invoice) {
      window.open(invoice.detail_link, `invoice-${invoice.id}`);
    },
    onInvoiceUpdate(data) {
      this.update({
        invoices: data.items,
        isLoading: false,
        pager: data,
        page: data.page
      });
      this.props.pagerBinder(data);
    },
    fetchInvoice(){
      this.props.MenuApi.request('invoice', 'fetch', this.props.params)
        .then(data => this.onInvoiceUpdate(data))
    },
    onBeforeMount(props, state){
      this.props.MenuApi.on('invoice:search', () => this.fetchInvoice());
      this.fetchInvoice();
    }
  }
</script>
</invoice-list-tag>
